import React from 'react';

const DonutChartCenter = ({ left, top, children, className = '', style }) => (
  <div
    className={`leadership-donut-center-label ${className}`.trim()}
    style={{ left, top, ...style }}
    aria-hidden="true"
  >
    {children}
  </div>
);

const DonutChartFrame = ({
  children,
  centerLabel,
  center = ['50%', '50%'],
  height,
  className = '',
  centerClassName = '',
  centerStyle,
}) => (
  <div
    className={`leadership-donut-chart-wrap ${className}`.trim()}
    style={{ height, width: '100%' }}
  >
    {children}
    {centerLabel != null && (
      <DonutChartCenter
        left={center[0]}
        top={center[1]}
        className={centerClassName}
        style={centerStyle}
      >
        {centerLabel}
      </DonutChartCenter>
    )}
  </div>
);

export default DonutChartFrame;
